module.exports = __webpack_public_path__ + "media/images/2-1cc09c3137067bbc05e269209eaaeeed.svg";